module.exports = __webpack_public_path__ + "static/media/map-marker-question.ce6aef23.svg";